import { ClientEnvironment, ClientEnvironmentName } from '../libraries/core/types/environment';

export const environment: ClientEnvironment = {
	production: false,
	environmentName: ClientEnvironmentName.DEVELOPMENT,
	clientId: 'default',
	frontendUrl: 'https://mobile.experimental.rea.ch',
	apiBaseUrl: 'https://api.experimental.rea.ch/',
	socialSignIn: {
		googleClientId: '106184129344-iphm6q5ab9tvvhq00gvmsb3f16kie2uo.apps.googleusercontent.com',
		appleClientId: 'ch.rea.app.signinweb',
		microsoftClientId: '3361613e-b173-498c-978f-20d709e6a56b',
		microsoftAuthority: 'common',
		microsoftTeamsIntegrationClientId: '3361613e-b173-498c-978f-20d709e6a56b',
		microsoftTeamsIntegrationAuthority: 'common',
		microsoftMyGenieClientId: '3361613e-b173-498c-978f-20d709e6a56b',
		microsoftMyGenieAuthority: 'common',
		microsoftSharepointIntegrationClientId: '3361613e-b173-498c-978f-20d709e6a56b',
		microsoftSharepointIntegrationAuthority: 'common',
		microsoftWidgetSecurityClientId: '3361613e-b173-498c-978f-20d709e6a56b',
		slackIntegrationClientId: '413594612722.12090196183761',
	},

	microsoftTeamsAppId: '3252e820-9271-4d92-a64f-9f9530432961',

	landingUrl: 'https://myreach.io',

	imageCdn: 'https://images.weserv.nl/',

	handbookUrl: 'https://handbook.experimental.rea.ch/',

	organizationDashboardUrl: 'https://mobile.experimental.rea.ch',
	myGenieServer: 'https://chat.experimental.rea.ch',
};
